<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 purchases-order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("PURCHASES_ORDERS.ADD_PURCHASES_ORDER") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <purchases-order-form
              :loading="loading"
              :purchasesOrderData="purchasesOrder"
              :formErrors="formErrors"
              @purchasesOrderSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultPurchasesOrder from "./defaultPurchasesOrder";
import PurchasesOrderForm from "./partials/PurchasesOrderForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    PurchasesOrderForm,
  },

  mixins: [alertLeave],

  data() {
    const purchasesOrder = cloneDeep(defaultPurchasesOrder);
    if (this.$currentUserIsLevelOrganization()) {
      purchasesOrder.organization = {
        type: "organizations",
        id: this.$currentUserOrganizationId(),
      };
    }
    return {
      purchasesOrder: purchasesOrder,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List PurchasesOrders" });
    },

    viewPurchasesOrder(purchasesOrder) {
      this.alertLeave = false;
      this.$router.push({
        name: "View PurchasesOrder",
        params: { id: purchasesOrder.id },
      });
    },

    async handleSubmit(purchasesOrder) {
      this.loading = true;
      const purchasesOrderData = cloneDeep(purchasesOrder);
      if (!purchasesOrderData.destinationWarehouse.id) {
        delete purchasesOrderData.destinationWarehouse;
      }
      try {
        await this.$store.dispatch("purchasesOrders/add", purchasesOrderData);
        this.$notify({
          type: "success",
          message: this.$t("PURCHASES_ORDERS.PURCHASES_ORDER_ADDED"),
        });
        const purchasesOrder = await this.$store.getters[
          "purchasesOrders/purchasesOrder"
        ];
        this.viewPurchasesOrder(purchasesOrder);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
